var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:`btn btn-primary no-disabler ${_vm.additionalClass}`,attrs:{"id":_vm.buttonId,"form":_vm.form,"type":"submit","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('i',{class:{
		'fa': true,
		[_vm.iconClass]: !_vm.isLoading,
		'fa-circle-o-notch fa-spin': _vm.isLoading,
	}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }